import "./index.css";
import { GridScene } from "./components/GridScene";
import { ThemeProvider } from "./lib/theme";

export function App() {
  return (
    <ThemeProvider>
      <GridScene />
    </ThemeProvider>
  );
}

export default App;
